<template>
  <page-container3>
    <div class="ant-pro-table">
      <div class="ant-pro-table-search">
        <search-render
          ref="config_render"
          :form="config"
          :model="config.model"
          :options="config_options"
          :validateInfos="validateInfos"
          @search="search"
        />
      </div>
      <a-card :body-style="{ padding: 0 }" ref="elRef">
        <div class="ant-pro-table-list-toolbar">
          <div class="ant-pro-table-list-toolbar-container">
            <div class="ant-pro-table-list-toolbar-left">
              <div class="ant-pro-table-list-toolbar-title">用户管理</div>
            </div>
            <div class="ant-pro-table-list-toolbar-right">
              <a-space align="center">
                <a-button
                  type="primary"
                  size="small"
                  @click="
                    () => {
                      editModal.visible = true;
                      editModal.title = '普通用户';
                      editModal.form.model = {};
                      editModal.aim_org_id = modelRef.aim_org_id;
                    }
                  "
                >
                  <plus-outlined />
                  普通用户
                </a-button>
                <a-button
                  type="primary"
                  size="small"
                  @click="
                    () => {
                      ptyhEditModal.visible = true;
                      ptyhEditModal.title = '新建门店负责人';
                      ptyhEditModal.form.model = {};
                      ptyhEditModal.aim_org_id = modelRef.aim_org_id;
                    }
                  "
                >
                  <plus-outlined />
                  门店负责人
                </a-button>

                <a-button
                  type="primary"
                  size="small"
                  @click="
                    () => {
                      jmsEditModal.visible = true;
                      jmsEditModal.title = '新建加盟商';
                      jmsEditModal.form.model = {};
                      jmsEditModal.aim_org_id = modelRef.aim_org_id;
                    }
                  "
                >
                  <plus-outlined />
                  加盟商
                </a-button>
                <a-button
                  type="primary"
                  size="small"
                  @click="
                    () => {
                      jkgsygEditModal.visible = true;
                      jkgsygEditModal.title = '新建供应链员工';
                      jkgsygEditModal.form.model = {};
                      jkgsygEditModal.aim_org_id = modelRef.aim_org_id;
                    }
                  "
                >
                  <plus-outlined />
                  供应链员工
                </a-button>
                <div class="ant-pro-table-list-toolbar-setting-item">
                  <a-tooltip title="表格斑马纹">
                    <a-switch
                      checked-children="开"
                      un-checked-children="关"
                      v-model:checked="state.stripe"
                    />
                  </a-tooltip>
                </div>
              </a-space>
              <div class="ant-pro-table-list-toolbar-divider">
                <a-divider type="vertical" />
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip title="刷新">
                  <reload-outlined @click="handleTableChange" />
                </a-tooltip>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip title="密度">
                  <a-dropdown :trigger="['click']" placement="bottomRight">
                    <column-height-outlined />
                    <template #overlay>
                      <a-menu
                        style="width: 80px"
                        :selected-keys="[state.tableSize]"
                        @click="
                          ({ key }) => {
                            state.tableSize = key;
                          }
                        "
                      >
                        <a-menu-item key="default">
                          <a href="javascript:;">默认</a>
                        </a-menu-item>
                        <a-menu-item key="middle">
                          <a href="javascript:;">中等</a>
                        </a-menu-item>
                        <a-menu-item key="small">
                          <a href="javascript:;">紧凑</a>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </a-tooltip>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-popover
                  placement="bottomRight"
                  arrowPointAtCenter
                  trigger="click"
                  overlayClassName="ant-pro-table-column-setting-overlay"
                >
                  <template #title>
                    <div class="ant-pro-table-column-setting-title">
                      <a-checkbox
                        v-model:checked="columnState.checkAll"
                        :indeterminate="columnState.indeterminate"
                        @change="handleColumnAllClick"
                      >
                        列展示
                      </a-checkbox>
                      <a @click="reset">重置</a>
                    </div>
                  </template>
                  <template #content>
                    <span class="ant-pro-table-column-setting-list">
                      <drag-container
                        lockAxis="y"
                        dragClass="ant-pro-table-drag-ghost"
                        dropClass="ant-pro-table-drop-ghost"
                        @drop="({ removedIndex, addedIndex }) => move(removedIndex, addedIndex)"
                      >
                        <draggable :key="column.key" v-for="column in dynamicColumnItems">
                          <div class="ant-pro-table-column-setting-list-item">
                            <drag-icon />
                            <a-checkbox
                              :checked="column.checked"
                              @change="handleColumnChange($event, column)"
                            >
                              {{ column.label }}
                            </a-checkbox>
                          </div>
                        </draggable>
                      </drag-container>
                    </span>
                  </template>
                  <a-tooltip title="列设置">
                    <setting-outlined />
                  </a-tooltip>
                </a-popover>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip :title="screenState ? '退出全屏' : '全屏'">
                  <fullscreen-outlined v-if="!screenState" @click="setFull" />
                  <fullscreen-exit-outlined v-else @click="exitFull" />
                </a-tooltip>
              </div>
            </div>
          </div>
        </div>
        <a-affix :offset-top="top">
          <a-table
            bordered
            :scroll="{ y: tableHeight.y }"
            :row-class-name="stripe"
            :size="state.tableSize"
            :loading="state.loading"
            :columns="dynamicColumns"
            :data-source="state.dataSource"
            :pagination="{
              current: state.current,
              pageSize: state.pageSize,
              total: state.total,
            }"
            @change="handleTableChange"
          >
            <template #index="{ index }">
              <span>{{ index + 1 + state.pageSize * (state.current - 1) }}</span>
            </template>
            <template #status="{ text }">
              <a-tag :color="statusMap[text].status">
                {{ statusMap[text].text }}
              </a-tag>
            </template>
            <template #wei="{ text }">
              <a-tag color="green" v-if="text">已绑定</a-tag>
              <a-tag color="red" v-if="!text">未绑定</a-tag>
            </template>
            <template #group="{ text }">
              <a-tag color="cyan" v-for="obj in text" :key="obj.id" style="margin-bottom: 1px">
                {{ obj.name }}
              </a-tag>
            </template>
            <template #flag_name_list="{ text, index }">
              <a-tag color="cyan" v-for="obj in text" :key="index" style="margin-bottom: 1px">
                {{ obj }}
              </a-tag>
            </template>
            <template #action="{ record }">
              <a-button
                type="primary"
                size="small"
                @click="() => handleOpenEdit(record)"
                v-if="record.is_active"
              >
                修改
              </a-button>
              <a-popconfirm v-if="record.is_active" @confirm="() => handleDelete(record)">
                <template #title>
                  <p>
                    是否确认禁用
                    <span style="color: dodgerblue">{{ record.realname }}</span>
                    ?
                  </p>
                </template>
                <a-button type="danger" size="small">禁用</a-button>
              </a-popconfirm>
              <a-button
                type="danger"
                size="small"
                @click="() => handleRecover(record)"
                v-if="!record.is_active"
              >
                恢复
              </a-button>
              <a-popconfirm
                v-if="record.is_active && is_super_user"
                @confirm="() => handleResetPassword(record)"
              >
                <template #title>
                  <p>
                    是否确认重置密码
                    <span style="color: dodgerblue">{{ record.realname }}</span>
                    ?
                  </p>
                </template>
                <a-button type="danger" size="small">重置</a-button>
              </a-popconfirm>
            </template>
          </a-table>
        </a-affix>
      </a-card>
    </div>
    <form-modal
      v-bind="editModal"
      v-if="editModal.visible"
      @cancel="
        () => {
          editModal.visible = false;
        }
      "
      @ok="handlerOk"
    />
    <form-modal
      v-bind="ptyhEditModal"
      v-if="ptyhEditModal.visible"
      @cancel="
        () => {
          ptyhEditModal.visible = false;
        }
      "
      @ok="handlerPtyhOk"
    />
    <form-modal
      v-bind="jmsEditModal"
      v-if="jmsEditModal.visible"
      @cancel="
        () => {
          jmsEditModal.visible = false;
        }
      "
      @ok="handlerJmsOk"
    />
    <form-modal
      v-bind="jkgsygEditModal"
      v-if="jkgsygEditModal.visible"
      @cancel="
        () => {
          jkgsygEditModal.visible = false;
        }
      "
      @ok="handlerJkgsygOk"
    />
  </page-container3>
</template>

<script lang="ts">
import { defineComponent, reactive, onMounted, ref, computed } from 'vue';
import { Badge } from 'ant-design-vue';
import {
  PlusOutlined,
  ReloadOutlined,
  ColumnHeightOutlined,
  SettingOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
} from '@ant-design/icons-vue';
import { Container as DragContainer, Draggable } from '@/components/draggable';
import {
  queryPerson,
  addPerson,
  updatePerson,
  removePerson,
  recoverPerson,
  resetPassword,
} from '@/api/permission/user-manage';
import { Pagination, TableFilters, TableColumn, TableColumnSortOrder } from '@/typing';
import { useFetchData } from '@/utils/hooks/useFetchData';
import { useFullscreen } from '@/utils/hooks/useFullscreen';
import { useTableDynamicColumns } from '@/utils/hooks/useTableColumn';
import DragIcon from '@/components/table/drag-icon.vue';
import FormModal from '../../../components/form-modal/form-modal.vue';
import { useStore } from 'vuex';
import { queryOrgList } from '@/api/sys';
import { message } from 'ant-design-vue';
import { useForm } from 'ant-design-vue/es/form';
import SearchRender from '@/components/FormRender/SearchRender.vue';
import {
  create_user_type_company_staff,
  create_user_type_jms,
  create_user_type_shop,
} from '@/api/mjstore-model';

const statusMap = {
  true: { text: '正常', status: 'green' },
  false: { text: '禁用', status: 'red' },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    slots: { customRender: 'index' },
  },
  {
    title: '名称',
    width: 150,
    dataIndex: 'realname',
  },
  {
    title: '关联账户',
    width: 300,
    dataIndex: 'flag_name_list',
    slots: { customRender: 'flag_name_list' },
  },
  {
    title: '手机号',
    width: 150,
    dataIndex: 'user__username',
  },
  {
    title: '角色',
    // width: 400,
    dataIndex: 'role_list',
    slots: { customRender: 'group' },
  },
  {
    title: '状态',
    width: 70,
    dataIndex: 'is_active',
    slots: { customRender: 'status' },
    filters: [
      {
        text: status[0],
        value: true,
      },
      {
        text: status[1],
        value: false,
      },
    ],
  },
  {
    title: '操作',
    width: 180,
    dataIndex: 'action',
    slots: { customRender: 'action' },
  },
];

export default defineComponent({
  name: 'UserManage',
  setup() {
    const store = useStore();
    const current_org = store.getters['user/current_org'];
    const tableHeight = reactive({ y: window.innerHeight - 130 });
    const is_super_user = computed(() => store.getters['user/is_super_user']);
    onMounted(() => {
      window.onresize = function () {
        tableHeight.y = window.innerHeight - 130;
      };
    });
    const {
      state: columnState,
      dynamicColumns,
      dynamicColumnItems,
      handleColumnAllClick,
      handleColumnChange,
      reset,
      move,
    } = useTableDynamicColumns(baseColumns, true);
    const [elRef, screenState, { setFull, exitFull }] = useFullscreen();
    const org_list: any = reactive([]);
    queryOrgList().then(res => {
      res.data.forEach(org => {
        org_list.push(org);
      });
      console.log(org_list);
    });
    const modelRef = reactive({
      org_id: current_org.id,
      aim_org_id: current_org.id,
      is_active: null,
      get_role: true,
      name: '',
      is_staff: true,
    });
    const config_options = {
      is_active: [
        { name: '全部', value: null },
        { name: '正常', value: true },
        { name: '禁用', value: false },
      ],
      aim_org_id: org_list,
    };
    const config = {
      settings: {
        name: '表单名称',
        labelAlign: 'right',
        layout: 'inline',
      },
      fields: [
        {
          type: 'select',
          name: 'aim_org_id',
          label: '目标组织',
          disabled: false,
          labelKey: 'name',
          valueKey: 'id',
          placeholder: '请填组织id',
          datasourceType: 'remote',
          datasource: 'aim_org_id',
          mode: 'default',
        },
        {
          type: 'input',
          name: 'name',
          label: '用户名称',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          maxlength: 100,
          defaultValue: '',
          placeholder: '请填写用户名称',
        },
        {
          type: 'remoteselect',
          name: 'role_id',
          label: '角色名称',
          disabled: false,
          placeholder: '请选择角色名称',
          datasourceType: 'remote',
          mode: 'default',
          allowClear: true,
          modalType: 'liyu_permission-role',
        },
        {
          type: 'select',
          name: 'is_active',
          label: '状态',
          mode: 'default',
          disabled: false,
          defaultValue: '',
          labelKey: 'name',
          valueKey: 'value',
          placeholder: '请选择状态',
          datasource: 'is_active',
        },
      ],
      rules: {},
      model: modelRef,
    };
    const { validateInfos } = useForm(modelRef, {});

    const {
      stripe,
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(queryPerson, {
      current: 1,
      pageSize: 20,
      tableSize: 'middle', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        ...modelRef,
        manage_type: [0, 1],
      },
    });
    const handleTableChange = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      setPageInfo({
        current,
        pageSize,
        ...filters,
        ...modelRef,
      });

      reload();
    };

    const search = () => {
      setPageInfo({
        current: 1,
        ...modelRef,
        manage_type: [0, 1],
      });
      reload();
    };
    //普通用户
    const ptyh_edit_model_config_options = {
      aim_org_id: org_list,
      gender: [
        { value: 0, name: '女' },
        { value: 1, name: '男' },
      ],
    };
    const ptyh_edit_model_config = {
      settings: {
        name: '表单名称',
        labelAlign: 'right',
        layout: 'horizontal',
      },
      fields: [
        {
          type: 'input',
          name: 'username',
          label: '手机号',
          disabled: false,
          allowClear: true,
          inputType: 'number',
          defaultValue: '',
          placeholder: '请填手机号',
        },
        {
          type: 'input',
          name: 'realname',
          label: '真实姓名',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          maxlength: 100,
          defaultValue: '',
          placeholder: '请填真实姓名',
        },
        {
          type: 'radio',
          name: 'gender',
          label: '性别',
          disabled: false,
          allowClear: true,
          labelKey: 'name',
          valueKey: 'value',
          defaultValue: '',
          placeholder: '请选择性别',
        },
        {
          type: 'remoteselect',
          name: 'role_id',
          label: '角色',
          disabled: false,
          placeholder: '请选择角色',
          datasourceType: 'remote',
          mode: 'default',
          allowClear: true,
          modalType: 'liyu_permission-role',
        },
        {
          type: 'remotemodal',
          name: 'shop_id',
          label: '门店',
          disabled: false,
          placeholder: '请选择门店',
          datasourceType: 'remote',
          mode: 'default',
          allowClear: true,
          modalType: 'mjstore-shop',
        },
        {
          type: 'datepicker',
          name: 'join_date',
          label: '入职日期',
          disabled: false,
          allowClear: true,
          inputType: 'number',
          defaultValue: '',
          showTime: false,
          placeholder: '请填写入职日期',
        },
      ],
      rules: {
        username: [{ required: true, message: '请输入正确手机号' }],
        realname: [{ required: true, message: '请输入真实姓名' }],
        join_date: [{ required: true, message: '请输入入职日期' }],
        role_id: [{ required: true, message: '请选择角色' }],
      },
      model: {
        id: null,
        username: '',
        realname: '',
        aim_org_id: '',
        shop_id: '',
        join_date: '',
      },
    };

    const ptyhEditModal = reactive({
      visible: false,
      loading: false,
      title: '',
      aim_org_id: '',
      form: ptyh_edit_model_config,
      options: ptyh_edit_model_config_options,
    });

    //加盟商
    const jms_edit_model_config = {
      settings: {
        name: '表单名称',
        labelAlign: 'right',
        layout: 'horizontal',
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      fields: [
        {
          type: 'input',
          name: 'username',
          label: '手机号',
          disabled: false,
          allowClear: true,
          inputType: 'number',
          defaultValue: '',
          placeholder: '请填手机号',
        },
        {
          type: 'input',
          name: 'realname',
          label: '加盟商名称',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          defaultValue: '',
          placeholder: '请填写加盟商名称',
        },
        {
          type: 'input',
          name: 'code',
          label: '加盟商编号',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          defaultValue: '',
          placeholder: '请填写加盟商编号',
        },
        {
          type: 'remoteselect',
          name: 'role_id',
          label: '角色',
          disabled: false,
          placeholder: '请选择角色',
          datasourceType: 'remote',
          mode: 'default',
          allowClear: true,
          modalType: 'liyu_permission-role',
        },
      ],
      rules: {
        username: [{ required: true, message: '请输入正确手机号' }],
        realname: [{ required: true, message: '请输入加盟商名称' }],
        code: [{ required: true, message: '请输入加盟商编号' }],
        role_id: [{ required: true, message: '请选择角色' }],
      },
      model: {
        id: null,
        username: '',
        realname: '',
        code: '',
      },
    };
    const jms_edit_model_config_options = {
      aim_org_id: org_list,
    };
    const jmsEditModal = reactive({
      visible: false,
      loading: false,
      title: '',
      aim_org_id: '',
      form: jms_edit_model_config,
      options: jms_edit_model_config_options,
    });

    //供应链员工
    const jkgsyg_edit_model_config = {
      settings: {
        name: '表单名称',
        labelAlign: 'right',
        layout: 'horizontal',
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      fields: [
        {
          type: 'input',
          name: 'username',
          label: '手机号',
          disabled: false,
          allowClear: true,
          inputType: 'number',
          defaultValue: '',
          placeholder: '请填手机号',
        },
        {
          type: 'input',
          name: 'realname',
          label: '供应链员工姓名',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          defaultValue: '',
          placeholder: '请填写供应链员工姓名',
        },
        {
          type: 'input',
          name: 'code',
          label: '供应链员工编号',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          defaultValue: '',
          placeholder: '请填写供应链员工编号',
        },
        {
          type: 'remoteselect',
          name: 'role_id',
          label: '角色',
          disabled: false,
          placeholder: '请选择角色',
          datasourceType: 'remote',
          mode: 'default',
          allowClear: true,
          modalType: 'liyu_permission-role',
        },
      ],
      rules: {
        username: [{ required: true, message: '请输入正确手机号' }],
        realname: [{ required: true, message: '请输入公司员工名称' }],
        code: [{ required: true, message: '请输入公司员工编号' }],
        role_id: [{ required: true, message: '请选择角色' }],
      },
      model: {
        id: null,
        username: '',
        realname: '',
        code: '',
      },
    };
    const jkgsyg_edit_model_config_options = {
      aim_org_id: org_list,
    };
    const jkgsygEditModal = reactive({
      visible: false,
      loading: false,
      title: '',
      aim_org_id: '',
      form: jkgsyg_edit_model_config,
      options: jkgsyg_edit_model_config_options,
    });

    //修改
    const edit_model_config_options = {
      aim_org_id: org_list,
    };

    const edit_model_config = {
      settings: {
        name: '表单名称',
        labelAlign: 'right',
        layout: 'horizontal',
      },
      fields: [
        {
          type: 'input',
          name: 'username',
          label: '手机号',
          disabled: false,
          allowClear: true,
          inputType: 'number',
          maxlength: 100,
          defaultValue: '',
          placeholder: '请填手机号',
        },
        {
          type: 'input',
          name: 'realname',
          label: '姓名',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          maxlength: 100,
          defaultValue: '',
          placeholder: '请填姓名',
        },
        {
          type: 'remoteselect',
          name: 'role_id',
          label: '角色',
          disabled: false,
          placeholder: '请选择角色',
          datasourceType: 'remote',
          mode: 'default',
          allowClear: true,
          modalType: 'liyu_permission-role',
        },
      ],
      rules: {
        username: [{ required: true, message: '请输入正确手机号' }],
        realname: [{ required: true, message: '请输入姓名' }],
        role_id: [{ required: true, message: '请选择角色' }],
      },
      model: {
        id: null,
        username: '',
        realname: '',
        email: '',
        role_id: '',
      },
    };
    const editModal = reactive({
      visible: false,
      loading: false,
      title: '',
      aim_org_id: '',
      form: edit_model_config,
      options: edit_model_config_options,
    });
    const currentRecord = reactive({ name: '' });
    const handleOpenEdit = (record: any) => {
      editModal.visible = true;
      editModal.title = '修改用户';
      let role_ids = record.role_list.map((item: any) => item.id);
      let role_id = '';
      if (role_ids.length > 0) {
        role_id = role_ids[0];
      }
      editModal.form.model = {
        ...record,
        username: record.user__username,
        aim_org_id: record.org_id,
        person_id: record.id,
        role_id: role_id,
      };
      Object.assign(currentRecord, record);
    };

    const handleDelete = (record: any) => {
      removePerson({ org_id: current_org.id, person_id: record.id }).then(res => {
        message.success('禁用用户成功');
        Object.assign(record, res);
      });
    };
    const handleRecover = (record: any) => {
      recoverPerson({ org_id: current_org.id, person_id: record.id }).then(res => {
        message.success('恢复用户成功');
        Object.assign(record, res);
      });
    };
    const handleResetPassword = (record: any) => {
      resetPassword({ org_id: current_org.id, username: record.user__username }).then(res => {
        message.success('重置密码成功');
        Object.assign(record, res);
      });
    };
    const handlerPtyhOk = (data: any) => {
      ptyhEditModal.loading = true;
      create_user_type_shop({ org_id: current_org.id, aim_org_id: current_org.id, ...data }).then(
        () => {
          message.success('新增用户成功');
          ptyhEditModal.visible = false;
          ptyhEditModal.loading = false;
          reload();
        },
      );
    };
    const handlerJmsOk = (data: any) => {
      jmsEditModal.loading = true;
      create_user_type_jms({ org_id: current_org.id, aim_org_id: current_org.id, ...data }).then(
        () => {
          message.success('新增用户成功');
          jmsEditModal.visible = false;
          jmsEditModal.loading = false;
          reload();
        },
      );
    };
    const handlerJkgsygOk = (data: any) => {
      jkgsygEditModal.loading = true;
      create_user_type_company_staff({
        org_id: current_org.id,
        aim_org_id: current_org.id,
        ...data,
      })
        .then(() => {
          message.success('新增用户成功');
          jkgsygEditModal.visible = false;
          jkgsygEditModal.loading = false;
          reload();
        })
        .finally(() => {
          jkgsygEditModal.loading = false;
        });
    };
    const handlerOk = (data: any) => {
      editModal.loading = true;
      if (!editModal.form.model.id) {
        addPerson({ org_id: current_org.id, aim_org_id: editModal.aim_org_id, ...data }).then(
          () => {
            message.success('新增用户成功');
            editModal.visible = false;
            editModal.loading = false;
            reload();
          },
        );
      } else {
        updatePerson({
          ...data,
          org_id: current_org.id,
          aim_org_id: current_org.id,
        }).then((res: any) => {
          Object.assign(currentRecord, res);
          message.success('修改用户成功');
          editModal.visible = false;
          editModal.loading = false;
        });
      }
    };

    return {
      statusMap,
      tableHeight,
      state,
      org_list,
      stripe,
      columnState,
      dynamicColumns,
      dynamicColumnItems,

      handlerOk,
      currentRecord,
      modelRef,
      validateInfos,
      // fullscreen
      elRef,
      screenState,
      setFull,
      exitFull,

      handleTableChange,
      search,

      handleColumnChange,
      handleColumnAllClick,
      reset,
      move,
      current_org,
      message,
      addPerson,
      updatePerson,
      removePerson,
      recoverPerson,
      // edit
      edit_model_config,
      edit_model_config_options,
      editModal,
      handleOpenEdit,
      handleDelete,
      handleRecover,
      reload,
      config,
      config_options,
      //普通用户
      ptyhEditModal,
      handlerPtyhOk,

      //加盟商
      jmsEditModal,
      handlerJmsOk,

      //健康公司员工
      jkgsygEditModal,
      handlerJkgsygOk,

      handleResetPassword,
      is_super_user,
    };
  },
  components: {
    DragIcon,
    PlusOutlined,
    ReloadOutlined,
    ColumnHeightOutlined,
    SettingOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
    Draggable,
    DragContainer,
    [Badge.name]: Badge,
    FormModal,
    SearchRender,
  },
});
</script>
